<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t("view") }} {{ $tc("vendor", 2) }}</div>
      <div>
        <router-link
          v-if="$can('update', 'Vendors')"
          class="btn-blue"
          :to="'edit-vendor?v_id=' + vendor_details.v_id"
          >{{ $t("edit") }}</router-link
        >
        <router-link class="btn-blue" to="vendors"
          >{{ $tc("view", 2) }} {{ $tc("vendor", 2) }}</router-link
        >
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $tc("vendor", 2) }} {{ $t("name") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ vendor_details.v_name }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("contactno") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ vendor_details.v_contact }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t("emailid") }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ vendor_details.v_email }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("tinnumber") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ vendor_details.v_tin_number }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t("taxtype") }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ vendor_details.v_tax_type }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t("address") }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ vendor_details.v_address }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $tc("country", 2) }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ selected.Country }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $tc("status", 1) }}
              </div>
              <div
                v-if="vendor_details.v_is_active == 'Y'"
                class="col-md-9 col-lg-10 col-xl-10"
              >
                {{ $t("active") }}
              </div>
              <div v-else class="col-md-9 col-lg-10 col-xl-10">
                {{ $t("inactive") }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <table class="table table-borderless w-75 mb-0">
              <thead>
                <tr>
                  <th class="pl-0">{{ $tc("rawmaterials", 2) }}</th>
                  <th>QTY</th>
                  <th>UOM</th>
                  <th>Price</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(
                    RawMaterial, RawMaterialIndex
                  ) in viewVendorRawMaterial"
                  :key="RawMaterialIndex"
                >
                  <td class="pl-0">{{ RawMaterial.name }}</td>
                  <td>{{ RawMaterial.vr_qty }}</td>
                  <td>{{ RawMaterial.uom_unit }}</td>
                  <td>{{ RawMaterial.vr_total_amount }}</td>
                </tr>
              </tbody>
            </table>
            <!-- <ul class="list-inline raw-mat-list font-weight-bold">
              <li class="list-inline-item">{{ $tc('rawmaterials', 2) }}</li>
              <li class="list-inline-item">QTY</li>
              <li class="list-inline-item">UOM</li>
              <li class="list-inline-item">Price</li>
            </ul>
            <ul
              v-for="(RawMaterial, RawMaterialIndex) in viewVendorRawMaterial"
              :key="RawMaterialIndex"
              class="list-inline raw-mat-list"
            >
              <li class="list-inline-item">{{ RawMaterial.name }}</li>
              <li class="list-inline-item">{{ RawMaterial.quantity }}</li>
              <li class="list-inline-item">{{ RawMaterial.uom }}</li>
              <li class="list-inline-item">{{ RawMaterial.price }}</li>
            </ul>-->
          </div>

          <div class="col-12" v-if="GetRoleId && GetRoleId === 1">
            <div class="row">
              <div class="col-md-12 py-2 border-bottom">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">
                    {{ $t("createdby") }}
                  </div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span>{{ vendor_details.created_by }}</span>
                  </div>
                </div>
              </div>

              <div class="col-md-12 py-2 border-bottom">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">
                    {{ $t("createdat") }}
                  </div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span class="mr-3">{{
                      vendor_details.created_at | dateparse
                    }}</span>
                    <!-- <span>12:05 AM</span> -->
                  </div>
                </div>
              </div>

              <div class="col-md-12 py-2 border-bottom">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">
                    {{ $t("modifiedby") }}
                  </div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span>{{ vendor_details.updated_by }}</span>
                  </div>
                </div>
              </div>

              <div class="col-md-12 py-2">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">
                    {{ $t("modifiedat") }}
                  </div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span class="mr-3">{{
                      vendor_details.updated_at | dateparse
                    }}</span>
                    <!-- <span>12:05 AM</span> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import PosFnbService from "@/services/PosFnbService";
import Multiselect from "vue-multiselect";
import { removeDuplicates } from "@/helper/collection";

const selected = {
  Country: "Select Country",
  State: "Select State",
  City: "Select City",
};
export default {
  components: { Multiselect },
  data() {
    return {
      selected: null,
      options: ["Kg", "Gms", "Lt", "Pks", "Ps"],
      vendor_details: {
        v_name: "",
        v_tin_number: "",
        v_tax_number: "",
        v_tax_type: "",
        v_address: "",
        city_id: "",
        state_id: "",
        country_id: "",
        v_contact: "",
        v_email: "",
        v_location: "",
        v_is_active: true,
        v_id: "",
      },
      Countries: [],
      States: [],
      Cities: [],
      selected: selected,
      viewVendorRawMaterial: [],
      Countries: [],
      CountriesMethod: {
        GET: "/admin/",
        tableName: "ms_countries",
        urlKey: "countries",
      },

      States: [],
      StatesMethod: {
        GET: "/admin/tablelist/",
        tableName: "ms_states",
        urlKey: "states",
      },

      Cities: [],
      CitiesMethod: {
        GET: "/admin/tablelist/",
        tableName: "ms_cities",
        urlKey: "cities",
      },
    };
  },
  beforeMount() {
    this.vendor_details.v_id = this.$route.query.v_id;
  },
  async mounted() {
    this.getVendorDetails();
    await this.getRawMaterials();
  },
  methods: {
    getRawMaterials: function (rm_id, rmv_id, index) {
      // console.log("rmv_id", rmv_id);
      let loader = this.$loading.show();

      let payload = {
        tableName: "ms_raw_materials",
        rm_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.RawMaterials = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(async () => {
          await this.getMappingDetails();
          setTimeout(() => loader.hide(), 1100);
        });
    },
    getMappingDetails: function () {
      this.viewVendorRawMaterial = [];
      // let payload = {
      //   tableName: "ln_raw_material_vendors",
      //   vendor_id: this.vendor_id
      // };
      // MasterService.GetVendorMappingDetails(payload)
      let payload = {
        vendor_id: this.vendor_details.v_id,
      };
      PosFnbService.GetVendorMappingDetails(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            // this.Cinemas = data.Records;
            this.viewVendorObject = {
              ...data.Records[0],
              cine_id: data.Records[0].cinema_id,
            };
            let obj = data.Records[0];

            data.Records.map((x, index) => {
              let array = this.RawMaterials.filter(
                (y) => y.rm_id === x.rawmaterial_id
              );
              if (array.length > 0) {
                let obj = {
                  name: array[0].rm_name,
                  rm_id: array[0].rm_id,
                  rmv_id: x.rmv_id,
                  vr_id: x.vr_id,
                  vr_qty: x.vr_qty,
                  vr_tax_amount: x.vr_tax_amount,
                  vr_total_amount: x.vr_total_amount,
                  vr_rate: x.vr_rate,
                  vr_is_active: true,
                  uom_id: x.uom_id,
                  uom_unit: x.uom_unit,
                };
                this.viewVendorRawMaterial.push(obj);
                // this.getunitsofmeasurements1(obj, index);
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    groupedCinemaWiseRawMaterial(records = []) {
      if (records.length > 0) {
        let groupedRM = _.groupBy(records, "cinema_id");
        let groupedArray = Object.values(groupedRM)[0];
        if (groupedArray && groupedArray.length > 0) {
          this.viewVendorRawMaterial = [];
          groupedArray.forEach((x) => {
            let array = this.RawMaterials.filter(
              (y) => y.rm_id === x.rawmaterial_id
            );
            if (array.length > 0) {
              let obj = {
                name: array[0].rm_name,
                rm_id: array[0].rm_id,
                rmv_id: x.rmv_id,
                vr_id: x.vr_id,
                vr_qty: x.vr_qty,
                vr_tax_amount: x.vr_tax_amount,
                vr_total_amount: x.vr_total_amount,
                vr_rate: x.vr_rate,
                vr_is_active: true,
                uom_id: x.uom_id,
                uom_unit: x.uom_unit,
              };
              this.viewVendorRawMaterial.push(obj);
            }
          });
        }
      }
    },
    getunitsofmeasurements1: function (obj) {
      let payload = {
        tableName: "ms_unit_of_measurement",
        uom_is_active: "Y",
        uom_id: obj.uom_id,
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            // this.UomList = data.Records;
            this.viewVendorRawMaterial.push({
              ...obj,
              uom: data.Records[0].uom_unit,
            });

            this.viewVendorRawMaterial = removeDuplicates(
              this.viewVendorRawMaterial,
              "rm_id"
            );
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getVendorDetails: function () {
      let payload = {
        tableName: "ms_vendors",
        v_id: this.vendor_details.v_id,
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            let obj = data.Records[0];
            this.vendor_details = obj;
            this.getCountriesList(obj.country_id || null);
            this.getStatesList(obj.country_id || null, obj.state_id || null);
            this.getCitiesList(obj.state_id || null, obj.city_id || null);
            Object.keys(this.vendor_details).map((x) => {
              if (x === "created_by") {
                this.getViewUsersDetails(this.vendor_details[x], "created_by");
              } else if (x === "updated_by") {
                this.getViewUsersDetails(this.vendor_details[x], "updated_by");
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    onSelectHandler: function (type, value) {
      if (type == "country") {
        this.selected.Country = value.country_name;
        this.vendor_details.country_id = value.country_id;
        this.getStatesList(value.country_id);
      } else if (type == "state") {
        this.selected.State = value.state_name;
        this.vendor_details.state_id = value.state_id;
        this.getCitiesList(value.state_id);
      } else if (type == "city") {
        this.selected.City = value.city_name;
        this.vendor_details.city_id = value.city_id;
      }
    },
    getCountriesList: function (country_id) {
      console.log("country_id :", country_id);
      this.Countries = [];
      let body = this.getRequestBody("GET", undefined, this.CountriesMethod);
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Countries = data.Records;
            if (country_id) {
              this.Countries.map((x) => {
                if (country_id === x.country_id) {
                  this.selected.Country = x.country_name;
                }
              });
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    getStatesList: function (country_id, state_id) {
      console.log("country_id, state_id :", country_id, state_id);
      this.States = [];
      let body = this.getRequestBody("GET", undefined, {
        ...this.StatesMethod,
        params: { id: "country_id-" + country_id },
      });
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.States = data.Records;
            if (state_id) {
              this.States.map((x) => {
                if (state_id === x.state_id) {
                  this.selected.State = x.state_name;
                }
              });
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    getCitiesList: function (state_id, city_id) {
      this.Cities = [];
      let body = this.getRequestBody("GET", undefined, {
        ...this.CitiesMethod,
        params: { id: "state_id-" + state_id },
      });
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cities = data.Records;
            if (city_id) {
              this.Cities.map((x) => {
                if (city_id === x.city_id) {
                  this.selected.City = x.city_name;
                }
              });
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    getViewUsersDetails(user_id, fieldvalue) {
      if (user_id) {
        MasterService.GetUserInfoById({ user_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.vendor_details[fieldvalue] = data.Records[0].user_name;
            } else {
              // Error Message
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            // Catch Error
            console.log("Catch Error on getViewUsersDetails :", error);
          });
      }
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/VendorsComponents/viewVendor.vue